export const PROJECT_BASE_QUERY_KEY = 'project';
